import { brandInfo } from '@/mocks/home';

export const channelsHeroData = {
  title: '策點文化合作購書通路',
  subtitle: '正式出版書籍查找與購買',
  description: '策點文化出版書籍可透過網站已建立的合作通路查找與購買。不同作品在各平台的上架狀態、版本、價格及庫存可能不同，實際資訊請以各通路頁面為準。',
};

export const channelList = [
  {
    id: 'ch-books',
    name: '博客來',
    icon: 'ri-book-open-line',
    url: 'https://www.books.com.tw/web/sys_puballb/books/?pubid=knowledge12',
    type: '線上書店',
  },
  {
    id: 'ch-eslite',
    name: '誠品',
    icon: 'ri-store-2-line',
    url: 'https://www.eslite.com/search?keyword=策點文化事業有限公司&manufacturer=WyLnrZbpu57mlofljJbkuovmpa3mnInpmZDlhazlj7giXQ&final_price',
    type: '線上書店',
  },
  {
    id: 'ch-kingstone',
    name: '金石堂',
    icon: 'ri-book-3-line',
    url: 'https://www.kingstone.com.tw/bookpublish/publist/62626/',
    type: '線上書店',
  },
  {
    id: 'ch-sanmin',
    name: '三民',
    icon: 'ri-booklet-line',
    url: 'https://www.sanmin.com.tw/search?pu=策點文化',
    type: '線上書店',
  },
  {
    id: 'ch-momo',
    name: 'momo',
    icon: 'ri-shopping-bag-3-line',
    url: 'https://www.momoshop.com.tw/search/策點文化?brand=策點文化',
    type: '電商平台',
  },
  {
    id: 'ch-shopee',
    name: '蝦皮',
    icon: 'ri-shopping-cart-2-line',
    url: 'https://shopee.tw/sonbook',
    type: '電商平台',
  },
  {
    id: 'ch-taaze',
    name: 'taaze讀冊',
    icon: 'ri-book-read-line',
    url: 'https://www.taaze.tw/rwd_searchResult.html?keyType%5B%5D=3&keyword%5B%5D=策點文化',
    type: '線上書店',
  },
  {
    id: 'ch-kobo',
    name: '樂天kobo',
    icon: 'ri-tablet-line',
    url: 'https://www.kobo.com/tw/zh',
    type: '電子書',
  },
  {
    id: 'ch-pubu',
    name: 'pubu',
    icon: 'ri-smartphone-line',
    url: 'https://www.pubu.com.tw/store/4193937',
    type: '電子書',
  },
  {
    id: 'ch-mybook',
    name: 'mybook',
    icon: 'ri-device-line',
    url: 'https://mybook.mobi/mybook/zh-TW/#',
    type: '電子書',
  },
];

export const channelFAQ = [
  {
    q: '策點文化 StratDot 的書可以在哪些通路購買？',
    a: '策點文化的出版作品透過博客來、誠品、金石堂、三民、momo、蝦皮、taaze讀冊等線上通路發行，電子書則可於樂天kobo、pubu、mybook等平台查找。各通路上架狀態可能不同，實際書籍資訊請以各平台頁面為準。',
  },
  {
    q: '為什麼有些書在特定通路上找不到？',
    a: '若在特定平台找不到書籍，建議先至崧博出版書籍資料庫確認正式書名、作者與ISBN，再前往其他已建立的合作通路查找。',
  },
  {
    q: '電子書與紙本書可以在哪些平台購買？',
    a: '紙本書主要透過博客來、誠品、金石堂、三民、momo、蝦皮、taaze讀冊等平台銷售。電子書可於樂天kobo、pubu、mybook等平台查找。不同平台的格式與上架狀態可能不同。',
  },
  {
    q: '未來會增加哪些合作通路？',
    a: '策點文化 StratDot 與崧博出版持續評估合作通路選擇。若有新通路上線，會透過官方管道公告。',
  },
];